const SectionEight = () => {
  return (
    <section className='bg-[url(/new-eight.png)] bg-cover bg-no-repeat pb-60 pt-20 text-center'>
      <h2 className='mt-10 text-4xl font-bold text-[#111827]'>Start Simple</h2>
      <p className='pt-4 font-inter text-base font-light text-[#111827]'>
        Easy and Efficient Validation Process. We have streamlined onboarding to
        save your time
      </p>

      <div className='container mx-auto mt-10 flex flex-col justify-center md:flex-row'>
        <div
          data-aos='fade-up'
          className='w-full rounded-lg border border-[#1B3C8E] bg-white p-5 text-left md:w-64 lg:w-72'
        >
          <div>
            <img
              className='h-14 w-14'
              src={'/icons/imtwo.png'}
              alt=''
              
              
            />
          </div>
          <div className='mb-2 mt-4'>
            <p className='font-Inter text-2xl font-bold text-[#12141D]'>
              Verify Basic Information
            </p>
          </div>
          <div>
            <p className='font-Inter text-sm font-light text-[#12141D]'>
              Confirm your organization&apos;s contact and location details
            </p>
          </div>
        </div>
        <img
          data-aos='zoom-in'
          className='mt-10 hidden h-20 px-4 md:hidden lg:block'
          src={'/icons/blue-pointer-down.png'}
          alt=''
          
          
        />
        <div
          data-aos='fade-down'
          className='relative top-0 w-full rounded-lg border border-[#1B3C8E] bg-white p-5 text-left md:top-16 md:w-64 lg:top-16 lg:w-72'
        >
          <div>
            <img
              className='h-14 w-14'
              src={'/share.png'}
              alt=''
              
              
            />
          </div>
          <div className='mb-2 mt-4'>
            <p className='font-Inter text-2xl font-bold text-[#12141D]'>
              Update your focus
            </p>
          </div>
          <div>
            <p className='font-Inter text-sm font-light text-[#12141D]'>
              Validate your geospatial expertise areas
            </p>
          </div>
        </div>
        <img
          data-aos='zoom-in'
          className='mt-10 hidden h-20 px-4 md:hidden lg:block'
          src={'/icons/blue-pointer-up.png'}
          alt=''
          
          
        />
        <div
          data-aos='fade-up'
          className='w-full rounded-lg border border-[#1B3C8E] bg-white p-5 text-left md:w-64 lg:w-72'
        >
          <div>
            <img
              className='h-14 w-14'
              src={'/icons/imthree.png'}
              alt=''
              
              
            />
          </div>
          <div className='mb-2 mt-4'>
            <p className='font-Inter text-2xl font-bold text-[#12141D]'>
              Share Use Cases
            </p>
          </div>
          <div>
            <p className='font-Inter text-sm font-light text-[#12141D]'>
              Highlight impactful projects
            </p>
          </div>
        </div>
      </div>
      {/* <div className='mt-32 grid items-center justify-center'>
        <Button className='h-[54px] w-[268px] border bg-transparent font-inter text-lg font-semibold'>
          Validate Your Profile
        </Button>
      </div> */}
      {/* <div className='mt-40 h-20'></div> */}
    </section>
  );
};

export default SectionEight;
